var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clicks-btn"},[_c('p',[_vm._v("Button clicked "),_c('b',[_vm._v(_vm._s(this.$store.state.count))]),_vm._v(" times")]),_vm._v(" "),_c('v-btn',{attrs:{"elevation":"2"},on:{"click":_vm.increment}},[_vm._v("Click me!")]),_vm._v(" "),_c('p',[_vm._v("This button uses state")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af2bd9b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClickComponent.vue
// module id = null
// module chunks = 